import { Inject, Injectable } from '@angular/core';
import { WINDOW } from './window.service';
import { AppConstants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(@Inject(WINDOW) private window: Window) {}

  readonly FAILED_LOGIN_CONTRACT_CANCELLED_KEY = 'FAILED_LOGIN_CONTRACT_CANCELLED';
  readonly FAILED_LOGIN_CONTRACT_KEY = 'FAILED_LOGIN_CONTRACT';
  readonly FAILED_LOGIN_USERGROUP_KEY = 'FAILED_LOGIN_USERGROUP';
  readonly SELECTED_CONTRACT_ID_KEY = 'SELECTED_CONTRACT_ID';
  readonly REDIRECT_TO_TECH_SUPPORT = 'REDIRECT_TO_TECH_SUPPORT';

  set redirectToTechSupport(value: boolean) {
    if (value) {
      this.window.sessionStorage.setItem(this.REDIRECT_TO_TECH_SUPPORT, '' + value);
    } else {
      this.window.sessionStorage.removeItem(this.REDIRECT_TO_TECH_SUPPORT);
    }
  }

  get redirectToTechSupport(): boolean {
    const redirectToTechSupport = this.window.sessionStorage.getItem(this.REDIRECT_TO_TECH_SUPPORT);
    return JSON.parse(redirectToTechSupport);
  }

  set failedLoginByContractCancalled(value: boolean) {
    if (value) {
      this.window.sessionStorage.setItem(this.FAILED_LOGIN_CONTRACT_CANCELLED_KEY, '' + value);
    } else {
      this.window.sessionStorage.removeItem(this.FAILED_LOGIN_CONTRACT_CANCELLED_KEY);
    }
  }

  get failedLoginByContractCancalled(): boolean {
    const hasFailedLogin = this.window.sessionStorage.getItem(this.FAILED_LOGIN_CONTRACT_CANCELLED_KEY);
    return JSON.parse(hasFailedLogin);
  }

  set failedLoginBycontract(value: boolean) {
    if (value) {
      this.window.sessionStorage.setItem(this.FAILED_LOGIN_CONTRACT_KEY, '' + value);
    } else {
      this.window.sessionStorage.removeItem(this.FAILED_LOGIN_CONTRACT_KEY);
    }
  }

  get failedLoginBycontract(): boolean {
    const hasFailedLogin = this.window.sessionStorage.getItem(this.FAILED_LOGIN_CONTRACT_KEY);
    return JSON.parse(hasFailedLogin);
  }

  set selectedContractId(value: string | null) {
    if (value) {
      this.window.sessionStorage.setItem(this.SELECTED_CONTRACT_ID_KEY, '' + value);
    } else {
      this.window.sessionStorage.removeItem(this.SELECTED_CONTRACT_ID_KEY);
    }
  }

  get selectedContractId(): string {
    return this.window.sessionStorage.getItem(this.SELECTED_CONTRACT_ID_KEY);
  }

  set selectedPlanNumber(value: string | null) {
    if (value) {
      this.window.localStorage.setItem(AppConstants.STORAGE_KEYS.SelectedPlanNumber, '' + value);
    } else {
      this.window.localStorage.removeItem(AppConstants.STORAGE_KEYS.SelectedPlanNumber);
    }
  }

  get selectedPlanNumber(): string {
    return this.window.localStorage.getItem(AppConstants.STORAGE_KEYS.SelectedPlanNumber);
  }

  set failedLoginByUserGroup(value: boolean) {
    if (value) {
      this.window.sessionStorage.setItem(this.FAILED_LOGIN_USERGROUP_KEY, '' + value);
    } else {
      this.window.sessionStorage.removeItem(this.FAILED_LOGIN_USERGROUP_KEY);
    }
  }

  get failedLoginByUserGroup(): boolean {
    const hasFailedLogin = this.window.sessionStorage.getItem(this.FAILED_LOGIN_USERGROUP_KEY);
    return JSON.parse(hasFailedLogin);
  }
}
